

































import Vue from 'vue';
import TIcons from '@/types/TIcons';

interface IModalComponent {
  icons: typeof TIcons;
  show: boolean;
}

export default Vue.extend({
  name: `Modal`,
  data(): IModalComponent {
    return {
      icons: TIcons,
      show: false,
    };
  },
  props: {
    disableBackdrop: {
      default: false,
      type: Boolean,
    },
    hideClose: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    closeModal(): void {
      this.show = false;
    },
    handleBackdrop(): void {
      if(!this.disableBackdrop) {
        this.closeModal();
      }
    },
    openModal(): void {
      this.show = true;
    },
  },
  watch: {
    show(value: boolean): void {
      const body = document.querySelector(`body`);
      if(body && value && this.$t) {
        body.classList.add(`overflow-hidden`);
      }
      if(body && !value && this.$t) {
        body.classList.remove(`overflow-hidden`);
      }
    },
  },
});
